import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect } from 'react';

export default function banner_Box(props) {
  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  const handleClick_custom = (e, item) => {
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '홍보 배너',
        clickType: 'NC',
        value1: item.pc_img_attr,
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  try {
    // 데이터가 1개라고 가정
    const banner = props.data.contents[0];

    return (
        <div className="contentsBlock_w">
          <div className="adBanner_w">
            <Link
                href={banner.pc_link_url}
                target={banner.link_new_yn === 'Y' ? '_blank' : ''}
                onClick={(e) => handleClick_custom(e, banner)}
                style={{ cursor: 'pointer' }} // This will change the cursor to a hand when hovering over the link
            >
              <img
                  src={banner.pc_img_url}
                  alt={banner.pc_img_attr || '배너광고영역'}
                  width="970"
                  height="90"
                  className="bnr_image"
                  style={{ cursor: 'pointer' }} // Optionally add the cursor change here as well
              />
            </Link>
          </div>
        </div>
    );
  } catch (error) {
    console.error('banner_Box render error:', error);
    return <></>;
  }
}
